exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".gce-security-group-wizard .sm-label-left {\n  border-bottom: 2px solid var(--color-seashell);\n}\n.gce-security-group-wizard .table {\n  border-top: 2px solid var(--color-white);\n}\n.gce-security-group-wizard .table .fixed-width {\n  width: 100%;\n}\n.gce-security-group-wizard .table .table-label {\n  padding: .8rem 0 0 1rem;\n}\n.gce-security-group-wizard .table .table-remove-button {\n  padding: 0 0 1rem 1rem;\n  margin-right: 65%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/google/src/securityGroup/configure/securityGroup.configure.less
// module id = 3700
// module chunks = 0